

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 8',
    id: 'SB4-U8-P63-E1',
    audio: 'img/FriendsPlus/Page63/Audio/audio-e1-p63.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page63/E1/Key/answerKey.png',
    textAlign: 'center',
    maxLength: 1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/tieude-e1-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E1/3.jpg' },
      ]
      ,
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/6.jpg', input: true, answer: "A" },
        { url: 'img/FriendsPlus/Page63/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page63/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/9.jpg', input: true, answer: "A" },
        { url: 'img/FriendsPlus/Page63/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/11.jpg', input: true, answer: "B" },
        { url: 'img/FriendsPlus/Page63/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page63/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/14.jpg', input: true, answer: "A" },
        { url: 'img/FriendsPlus/Page63/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/16.jpg', input: true, answer: "B" },
        { url: 'img/FriendsPlus/Page63/E1/17.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page63/E1/18.jpg' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'SB4-U8-P63-E2',
    audio: '',
    video: '',
    component: D1,
    recorder: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E2/1.jpg' },
      ]
    ],
  },
  3: { // Exercise num
    unit: 'Unit 8',
    id: 'SB4-U8-P63-E3',
    audio: '',
    video: '',
    component: D1,
    // checkDuplicated: true,
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page63/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/3.jpg', input: true, answer: "small/little/tall" },
        { url: 'img/FriendsPlus/Page63/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/5.jpg', input: true, answer: "red/pink/blue" },
        { url: 'img/FriendsPlus/Page63/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/7.jpg', input: true, answer: "little, pink" },
        { url: 'img/FriendsPlus/Page63/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/10.jpg', input: true, answer: "small/little/tall" },
        { url: 'img/FriendsPlus/Page63/E3/11.jpg', input: true, answer: "small/little/tall" },
        { url: 'img/FriendsPlus/Page63/E3/12.jpg', input: true, answer: "red/pink/blue" },
        { url: 'img/FriendsPlus/Page63/E3/13.jpg', input: true, answer: "red/pink/blue" },
        { url: 'img/FriendsPlus/Page63/E3/14.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page63/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/16.jpg', input: true, answer: "tall, green" },
        { url: 'img/FriendsPlus/Page63/E3/17.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page63/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page63/E3/19.jpg', input: true, answer: "small, blue" },
        { url: 'img/FriendsPlus/Page63/E3/20.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page63/E3/21.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page63/E3/22.jpg' },
      ],

    ],
  },
  4: { // Exercise num
    unit: 'Unit 8',
    id: 'SB4-U8-P63-E4',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page63/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page63/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page63/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page63/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page63/E4/11.jpg' },
      ],


    ],
  },
}
export default json;
